import type { GetProductNormalized } from '@messenger/types'

/** One MDL product as the Transparent Print page lists it. */
export type PrintProductRow = {
  id: string
  name: string
  enabled: boolean
}

/**
 * The rows the page lists: MDL products that are not archived, by name. M3
 * products are left out; the M3 admin's product editor owns their flag.
 */
export const toPrintProductRows = (
  products: readonly GetProductNormalized[],
): PrintProductRow[] =>
  products
    .filter((product) => product.source === 'mdl' && !product.archived)
    .map((product) => ({
      id: product.id,
      name: product.name,
      enabled: product.transparent_print_background === true,
    }))
    .sort((a, b) => a.name.localeCompare(b.name))

/** The rows whose name holds `query`, ignoring case; every row for a blank query. */
export const filterPrintProductRows = (
  rows: readonly PrintProductRow[],
  query: string,
): PrintProductRow[] => {
  const needle = query.trim().toLowerCase()
  if (needle === '') return [...rows]
  return rows.filter((row) => row.name.toLowerCase().includes(needle))
}
